import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for platform /assessments/:templateId/*. Renders <Outlet /> so
 * child routes can mount here. Platform has no assign children today, but the
 * layout split keeps the structure symmetric with workspace and future-proofs
 * adding a nested route here.
 */
export const Route = createFileRoute('/_staff/admin/platform/assessments/$templateId')({
  beforeLoad: () => {
    requirePermission('assessment:read');
  },
  component: PlatformAssessmentLayout,
  staticData: { crumb: 'Template' },
});

function PlatformAssessmentLayout() {
  return <Outlet />;
}
